import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { Task } from '../../../../shared/entities/task/task';
import { ControlTemplate } from '../../../form/entities/controlTemplate';
import { EditDialogService } from '../../../../../core/components/editDialog/editDialogService';
import { CommandTemplate } from '../../../../../core/entities/commandTemplate/commandTemplate';
import { TaskFormHandler } from '../task-form-handler.interface';
import { RentalResourceAssignmentReviewFormHandler } from '../rental-resource-assignment-review-form.handler';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ReviewFormDialogComponent } from './review-form-dialog.component';

/**
 * Review form view component for rental resource assignment review tasks
 */
@Component({
  selector: 'app-review-form-view',
  template: `
    <div>
      @if(reviewHandler()?.resourceAssignments()?.length > 0) {
        @for (assignment of reviewHandler()?.resourceAssignments(); track assignment.id) {
        <div class="top flex flex-col px-5 py-[0.313rem] bg-white min-w-[485px] block border-b border-gray first:border-t ng-star-inserted">
          <div class="flex flex-row">
            <div class="grow">
              <div class="flex flex-row">
                <div class="text-base font-medium leading-3r cursor-pointer">
                  {{assignment?.resource?.text}}
                </div>
              </div>
              <div class="text-base text-[#848488] leading-3 ng-star-inserted">
                {{assignment?.lineItem?.article?.name}}
              </div>
            </div>
          </div>
        </div>
        }
      }
    </div>
    <div class="flex justify-end mt-2">
      @if(task()?.state !== 'COMPLETED') {
      <nx-default-button
        [style]="'accent'"
        [disabled]="disabled()"
        [pTooltip]="disabled() ? 'Im Web nicht verfügbar.' : undefined"
        [label]="'Start'"
        (click)="start()">
      </nx-default-button>
      } @else {
      <nx-default-button
        [style]="'accent'"
        [disabled]="true"
        [label]="'Erledigt'">
      </nx-default-button>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReviewFormViewComponent {
  readonly task = input.required<Task>();
  readonly template = input<ControlTemplate | null>(null);
  readonly commandTemplate = input<CommandTemplate | null>(null);
  readonly disabled = input(true);
  readonly handler = input.required<TaskFormHandler>();
  
  readonly complete = output<any>();
  
  // Injected services
  private readonly dialogService = inject(EditDialogService);
  
  dialogRef: DynamicDialogRef | undefined;
  
  // Type-safe accessor for the specific handler
  readonly reviewHandler = computed(() => 
    this.handler() as RentalResourceAssignmentReviewFormHandler
  );

  start() {
    this.dialogRef = this.dialogService.open(ReviewFormDialogComponent, {
      header: 'Prüfen',
      confirmLabel: 'Als erledigt markieren',
      width: '800px',
      data: {
        task: this.task(),
        template: this.template(),
        resourceAssignments: this.reviewHandler().resourceAssignments()
      }
    });
    
    this.dialogRef.onClose.subscribe((result) => {
      if (result) {
        this.complete.emit(result);
      }
    });
  }
}
